export function getMenus(state) {
  return state.menus;
}

export function getSelectedMenu(state) {
  return state.selectedMenu;
}
// en linea
export function vacationMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 1);
}

export function permissionMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 5);
}

export function cardWorkMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 14);
}

export function selectionMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 17);
}

export function developmentMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 22);
}

export function trainMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 25);
}

export function renumerationMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 31);
}

export function certificationMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 35);
}

// informados
export function postMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 38);
}
export function politicMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 42);
}
export function guardianMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 53);
}
export function integralMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 56);
}
export function recognizeMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 59);
}
export function opportunityMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 65);
}

export function programMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 68);
}
export function celebrateMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 71);
}
export function helpMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 75);
}
export function openMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 78);
}
export function cultureMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 81);
}
export function freeMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 82);
}
// MIS BENEFICIOS
export function bonusMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 91);
}
export function creditMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 105);
}
export function secureMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 108);
}
export function becaMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 113);
}
export function freeTimeBMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 116);
}
export function familyMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 125);
}
export function celebrateBMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 132);
}
export function helthSMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 149);
}
export function covenantGMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 157);
}
export function covenantCMenu(state) {
  return state.menus.filter(menu => menu.parent_id === 164);
}
